import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconH1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 24,
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M5.896 16.494c0 1.755 0 3.509-0.040 5.203l-1.855 0.222v0.827h5.687v-0.827l-1.835-0.202c-0.040-1.654-0.040-3.348-0.040-5.405h6.514c0 1.875 0 3.67-0.040 5.385l-1.855 0.222v0.827h5.687v-0.827l-1.855-0.222c-0.040-1.734-0.040-3.469-0.040-5.203v-0.988c0-1.755 0-3.509 0.040-5.203l1.855-0.222v-0.827h-5.687v0.827l1.855 0.222c0.040 1.634 0.040 3.287 0.040 5.062h-6.514c0-1.613 0-3.368 0.040-5.082l1.835-0.202v-0.827h-5.687v0.827l1.855 0.222c0.040 1.734 0.040 3.469 0.040 5.203v0.988zM20.74 10.625v0.827l2.662-0.222v7.26c0 1.008-0.020 2.037-0.040 3.045l-2.844 0.484v0.726h7.482v-0.726l-2.864-0.484c-0.020-1.008-0.040-2.037-0.040-3.045v-5.848l0.081-2.884-0.282-0.202-4.154 1.069z"
	})
});
export { SvgIconH1 as ReactComponent };
